import React from 'react'
import { Card, Text } from '@mantine/core'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface EvolutionChartProps {
  title: string
  data: { label: string; date: string; count: number }[]
  lineColor: string
  className?: string
}

const EvolutionChart: React.FC<EvolutionChartProps> = ({ title, data, lineColor, className }) => {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder className={className}>
      <Text fw={600} size="md" mb="md">
        {title}
      </Text>
      <div style={{ height: 300, width: '100%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="label"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#6b7280' }}
              dy={10}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#6b7280' }}
            />
            <Tooltip
              contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
            />
            <Line
              type="monotone"
              dataKey="count"
              name="Avis"
              stroke={lineColor}
              strokeWidth={2}
              dot={{ r: 4, fill: lineColor }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  )
}

export default EvolutionChart
